import {
  BpmnDisplayActionsTypes,
  UpdateNodesNamesAction
} from '../actions';
import { initialState } from '../state';

export function nodesNamesSuffixes(state = initialState.nodesNamesSuffixes, action: UpdateNodesNamesAction): any {
  switch (action.type) {
    case BpmnDisplayActionsTypes.UPDATE_NODES_NAMES:
      return action.payload.nodeIdToNameSuffixDictionary ? action.payload.nodeIdToNameSuffixDictionary : { };
    default: {
      return state;
    }
  }
}
